module.exports = __webpack_public_path__ + "img/项目进度.d0f45964.svg";